module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-backStage"
  }, [_c('backMenu'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('router-link', {
    attrs: {
      "tag": "div",
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/image/back-to-front.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("进入前台")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "router",
    class: {
      side: _vm.$route.name != 'backhome'
    }
  }, [_c('transition', {
    attrs: {
      "name": "backpage"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "backpage"
    }
  }, [_c('home', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name == 'backhome'),
      expression: "$route.name=='backhome'"
    }]
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-12d13c0c!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/backEndStage/page-endhome.vue
// module id = 693
// module chunks = 1